<template>
  <v-container class="px-6">
      <v-row>
          <v-col class="" cols="12">
              <h1>Identificação nas operadoras</h1>
              <p>
                Gerencie os logins de identificação utilizados para acesso às operadoras.
                <br> O login e senha devem ser os mesmos cadastrados na operadora.
              </p>
          </v-col>

          <v-col class="" cols="12">
              <IdentificacaoFilter
                :operadoras="listOperadora"
                :prestadores="prestadores"
                :filterList="(formData) => getList(formData)"
                :getOperadoras="(prestadores_ids)=>atualizaComboOperadoras(prestadores_ids)"
                :updateFilter="(filter)=>filterData=filter"
              />
          </v-col>
      </v-row>
      <v-row>
        <v-tabs v-model="tab" @change="mudarAba" class="elevation-0 px-3">
            <v-tab href="#Recebiveis" v-if="userData.PermissaoAcoes.recebiveis && userData.PermissaoAcoes.recebiveis.includes( 'getidentificacaooperadora')">FATURAMENTO E RECEBÍVEIS</v-tab>
            <v-tab href="#Portal" v-if="Object.keys(userData.Permissao).includes('autorizador') && userData.PermissaoAcoes.portal.includes( 'getidentificacaooperadoraautorizador')">AUTORIZADOR</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" style="min-height:60vh; min-width: 100%" class="elevation-0 px-3">
            <v-tab-item value="Recebiveis">
                    <IdentificacaoList
                        :list="listRecebiveis"
                        :pagination="paginationRecebiveis"
                        :filterData="filterData"
                        :userData="userData"
                        :getList="(filter) => getList(filter)"
                        :sendEdit="(item) => updateData(item)"
                        :showOpen="(item) => showOpen(item)"
                    />
            </v-tab-item>
            <v-tab-item value="Portal">
                    <IdentificacaoListAutorizador
                        :list="listAutorizador"
                        :pagination="paginationAutorizador"
                        :filterData="filterData"
                        :userData="userData"
                        :getList="(filter) => getList(filter)"
                        :sendEdit="(item) => updateDataAutorizador(item)"
                        :showOpen="(item) => showOpen(item)"
                    />
            </v-tab-item>
        </v-tabs-items>
          <HistoricoEventosDlg
            :dialog="dialog"
            :close="() => close()"
            :historico="historico"
            />
      </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import HistoricoEventosDlg from '../components/identificacao_operadoras/HistoricoEventosDlg'
import IdentificacaoFilter from '../components/identificacao_operadoras/IdentificacaoFilter'
import IdentificacaoList from '../components/identificacao_operadoras/IdentificacaoList'
import IdentificacaoListAutorizador from '../components/identificacao_operadoras/IdentificacaoListAutorizador'
export default {
    components: {
        HistoricoEventosDlg,
        IdentificacaoFilter,
        IdentificacaoList,
        IdentificacaoListAutorizador
    },
    data() {
        return {
            dialog: false,
            filterData: { grupo_economico: this.grupoEconomico, prestador_id: [], operadora_ans_id: [], login_valido: null },
            historico: {
                list: [],
                header: {
                    prest_nome: null, 
                    oper_nome: null, 
                    WEB_LU: null,
                    WEB_IU: null
                }
            },
            listAutorizador: [],
            listOperadora: [],
            listRecebiveis: [],
            paginationAutorizador: {
                limit: 10,
                offset: 1,
                current_page: 1,
            },
            paginationRecebiveis: {
                limit: 10,
                offset: 1,
                current_page: 1,
            },
            prestadores: [],
            tab: "Recebiveis"
        }
    },
    computed: {
        ...mapState({
            grupoEconomico: (state) => state.permissions.grupoEconomico,
            grupoEconomicoList: (state) => state.permissions.grupoEconomicoList,
            userData: (state) => state.userData.userData
        }),
    },
    watch: {
        grupoEconomicoList: {
            deep: true,
            handler() {
                this.prestadores = this.$store.getters[
                "permissions/getPrestadoresByGeco"
                ]();
            },
        },
    },
    mounted() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
        let userData = this.$store.state.userData.userData
        this.controlResponsavel = !userData.Permissao.faturamento.includes('gestor')
        this.atualizaComboOperadoras()
    },
    methods: {
        ...mapActions('permissions', [
            "getOperadoras",
        ]),
        async atualizaComboOperadoras(prestadores_ids) {
            let opts = {
                grupoEconomico: this.grupoEconomico,
                modulo_operadora: this.tab== "Portal" ? "Autorizador" : "Recebiveis",
                prestador_ids: prestadores_ids? prestadores_ids : this.filterData.prestador_id
            }
            await this.getOperadoras(opts).then((resp) => {
                this.listOperadora = resp
            })
        },
        showOpen(opt) {
            let {prestador_id, operadora_ans_id, identificador_prestador} = opt
            let obj = {
                query: [{
                    Modulo: this.tab,
                    Acao: this.tab == "Portal"? "gethistoricoeventoautorizador" : "gethistoricoevento" ,
                    Payload: {
                        grupo_economico: this.grupoEconomico,
                        prestador_id, 
                        operadora_ans_id, 
                        identificador_prestador,
                        evento_id: 100
                    },
                }],
            }
            this.$store.dispatch('request/doRequest', obj).then((response) => {
                if (!response || response.isAxiosError || response.error) {
                    this.$store.commit("hideLoader")
                    return
                }
                let { prest_nome, oper_nome, WEB_LU,  } = opt
                this.historico.list = response.dados
                this.historico.header = {prest_nome, oper_nome, WEB_LU}
                this.dialog = true
            })
        },
        close() {
            this.dialog = false
        },
        getList(filter) {
            this.filterData = filter
            let Modulo = this.tab;
            let Acao = this.tab== "Portal" ? 'getidentificacaooperadoraautorizador' : "getidentificacaooperadora";
            let listName = this.tab== "Portal" ? "listAutorizador" : "listRecebiveis";
            let payload = filter != null 
            ? { grupo_economico: this.grupoEconomico, ...filter }
            : { grupo_economico: this.grupoEconomico, prestador_id: [], operadora_ans_id: [], login_valido: null }
            let obj = {
                query: [{
                    Modulo,
                    Acao,
                    Payload: payload
                }],
            }
            this.$store.dispatch('request/doRequest', obj).then((response) => {
                if (!response || response.isAxiosError || response.error) {
                    this.$store.commit("hideLoader")
                    return
                }
                let { dados } = response
                this[listName] = dados
            })
        },
        mudarAba() {
            this.atualizaComboOperadoras().then(() => {
                this.getList(this.filterData)
            })
        },
        updateData(opt) {
            let obj = {
                query: [{
                    Modulo: "Recebiveis",
                    Acao: "updateidentificacaooperadora",
                    Payload: {
                        grupo_economico: this.grupoEconomico,
                        id: opt.id,
                        WEB_IU: opt.WEB_IU, 
                        WEB_LP: opt.WEB_LP,
                        WEB_LU: opt.WEB_LU
                    },
                }],
            }
            this.$store.dispatch('request/doRequest', obj).then((response) => {
                if (!response || response.isAxiosError || response.error) {
                this.$store.commit("hideLoader")
                return
                }
                let paramModal = {
                    type: "success",
                    title: "Sucesso!",
                    message: response.mensagem,
                    callback: () => {
                        this.getList(null)
                    },
                    btConfirm: { name: "Ok", show: true },
                    btCancel: { name: "Não", show: false }
                }
                this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
            })
        },
        updateDataAutorizador(opt) {
            let obj = {
                query: [{
                    Modulo: "Portal",
                    Acao: "updateidentoperautorizador",
                    Payload: {
                        grupo_economico: this.grupoEconomico,
                        ...opt
                    },
                }],
            }

            if(opt.WEB_LP == null || opt.WEB_LP == '' || opt.WEB_LU == null || opt.WEB_LU == ''){
                let paramModal = {
                    type: "error",
                    title: "Aviso!",
                    message: "Necessário ter Login e Senha para atualizar",
                    callback: () => {
                        //this.getList(this.filterData)
                    },
                    btConfirm: { name: "Ok", show: true },
                    btCancel: { name: "Não", show: false }
                }
                this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
                return
            }
            
            this.$store.dispatch('request/doRequest', obj).then((response) => {
                if (!response || response.isAxiosError || response.error) {
                this.$store.commit("hideLoader")
                return
                }
                let paramModal = {
                    type: "success",
                    title: "Sucesso!",
                    message: response.mensagem,
                    callback: () => {
                        this.getList(null)
                    },
                    btConfirm: { name: "Ok", show: true },
                    btCancel: { name: "Não", show: false }
                }
                this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
            })
        },
        // filterList(formData) {
        //     this.filter = formData
        //     let list = Array.from(this.list)
        //     let newList = [];
        //     if (formData && list.length) {
        //         newList = list.reduce((arr, item) => {
        //         let matchPres = formData.prestador_id == item.prestador_id || formData.prestador_id == null
        //         let matchOper = formData.operadora_ans_id == item.operadora_ans_id || formData.operadora_ans_id == null
        //         let matchStatus = formData.status_validacao == item.status_validacao || formData.status_validacao == null
        //         if(matchPres && matchOper && matchStatus) {
        //             arr.push(item);
        //         }
        //         return arr
        //         }, [])
        //     }
        //     this.lotesFilter = newList
        // },
    }
    
}
</script>

<style>

</style>